import { ReactNode } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition, faInfoCircle } from '@fortawesome/pro-light-svg-icons'

import { IconWithMenu, Link, Text } from '@domain-group/suit-theme'

const InfoToolTip = (props: { children: ReactNode, icon?: IconDefinition }) => {
  const { children, icon = faInfoCircle } = props

  return (
    <IconWithMenu
      icon={(
        <Link greyLink>
          <FontAwesomeIcon icon={icon} />
        </Link>
      )}
    >
      {/*
       // @ts-expect-error TS2741 */}
      <IconWithMenu.Menu closeOnClick>
        <Text color="bodyFontLightColor" lineHeight={1.3} padding="large" width={300}>
          {children}
        </Text>
      </IconWithMenu.Menu>
    </IconWithMenu>
  )
}

export default InfoToolTip
